module.exports = __webpack_public_path__ + "img/form-1-punch-bg.052f8859.png";